import dayjs from "dayjs";
import { useState, useEffect } from "react";

const useGMTTime = (cityInfo) => {
  const [offset, setOffset] = useState(0);
  const [formattedTime, setFormattedTime] = useState("");

  
  useEffect(() => {
    if (cityInfo) {
      setOffset(cityInfo.tz_offset);
}
  },[cityInfo])
    // Step 2: Parse the JSON data

  
 
  useEffect(() => {
    const updateFormattedTime = () => {
      let date = new Date();
      let utcTime = date.getTime() + date.getTimezoneOffset() * 60000;
      let localTime = new Date(utcTime + offset * 3600000);

      let formattedTime =
        localTime.getFullYear() +
        "-" +
        String(localTime.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(localTime.getDate()).padStart(2, "0") +
        " " +
        String(localTime.getHours()).padStart(2, "0") +
        ":" +
        String(localTime.getMinutes()).padStart(2, "0") +
        ":" +
        String(localTime.getSeconds()).padStart(2, "0");

      setFormattedTime(formattedTime);
    };

    updateFormattedTime();
    const interval = setInterval(updateFormattedTime, 1000);

    return () => clearInterval(interval);
  }, [offset]);

  return { formattedTime };
};

export default useGMTTime;

 
